export default {
  common: {
    loading: 'Đang tải...',
    error: 'Lỗi',
    success: 'Thành công',
    save: 'Lưu',
    cancel: 'Hủy',
    edit: 'Sửa',
    delete: 'Xóa',
    confirm: 'Xác nhận',
    back: 'Quay lại',
    signOut: 'Đăng xuất',
    actions: 'Hành động',
    search: 'Tìm kiếm',
    searching: 'Đang tìm kiếm...',
    select: 'Chọn...',
    useMyLocation: 'Sử dụng vị trí của tôi',
    locating: 'Đang xác định vị trí...',
    pickFromMap: 'Chọn vị trí từ bản đồ',
    hideMap: 'Ẩn bản đồ',
    allItemsLoaded: 'Tất cả các mục đã tải',
    operatorLocations: 'Địa điểm theo nhà điều hành',
    searchResults: 'Tìm thấy {{count}} địa điểm khớp với "{{term}}"',
    loadMore: 'Tải thêm',
    optional: 'Tùy chọn',
  },
  auth: {
    login: 'Đăng nhập',
    register: 'Đăng ký',
    logout: 'Đăng xuất',
    email: 'Email',
    password: 'Mật khẩu',
    confirmPassword: 'Xác nhận mật khẩu',
    forgotPassword: 'Quên mật khẩu?',
    currentPassword: 'Mật khẩu hiện tại',
    newPassword: 'Mật khẩu mới',
  },
  dashboard: {
    title: 'Bảng điều khiển',
    operators: 'Nhà điều hành',
    chargePoints: 'Điểm sạc',
    settings: 'Cài đặt',
    navigation: {
      dashboard: 'Bảng điều khiển',
      operators: 'Nhà điều hành',
      chargePoints: 'Điểm sạc',
      settings: 'Cài đặt',
      users: 'Người dùng',
      transactions: 'Giao dịch',
      rfidTags: 'Thẻ RFID',
    },
    stats: {
      totalOperators: 'Tổng số nhà điều hành',
      totalLocations: 'Tổng số địa điểm',
      totalChargePoints: 'Tổng số điểm sạc',
      activeChargingSessions: 'Phiên sạc đang hoạt động',
      recentActivities: 'Hoạt động gần đây',
      noActivities: 'Không có hoạt động gần đây',
      lastUpdated: 'Cập nhật lần cuối',
      updatedRealtime: 'Cập nhật theo thời gian thực',
      status: {
        available: 'Sẵn sàng',
        inUse: 'Đang sử dụng',
        maintenance: 'Bảo trì',
        offline: 'Ngoại tuyến',
        active: 'Hoạt động',
        inactive: 'Không hoạt động'
      },
      chargePointStatus: 'Trạng thái điểm sạc',
      locationStatus: 'Trạng thái địa điểm'
    }
  },
  settings: {
    title: 'Cài đặt',
    language: 'Ngôn ngữ',
    currency: 'Tiền tệ',
    darkMode: 'Chế độ tối',
    notifications: {
      title: "Cài đặt thông báo",
      firebase: 'Firebase',
      fcmServerKey: "Khóa máy chủ Firebase Cloud Messaging",
      fcmServerKeyPlaceholder: "Nhập khóa máy chủ FCM của bạn",
      fcmServerKeyHelp: "Cần thiết để gửi thông báo đẩy đến thiết bị Android",
      apple: 'Apple',
      apnsKeyId: "ID Khóa Apple Push Notification",
      apnsKeyIdPlaceholder: "Nhập ID Khóa APNs của bạn",
      apnsTeamId: "ID Nhóm phát triển Apple",
      apnsTeamIdPlaceholder: "Nhập ID Nhóm phát triển Apple của bạn",
      apnsBundleId: "ID Gói ứng dụng Apple",
      apnsBundleIdPlaceholder: "com.congty.app",
      apnsProduction: "Sử dụng môi trường sản xuất APNs",
      testNotification: "Gửi thông báo thử nghiệm"
    },
    paymentGateways: 'Cổng thanh toán',
    adminSettings: 'Cài đặt quản trị',
    operatorSettings: 'Cài đặt vận hành',
    paymentGatewayInheritMessage: 'Bạn đang sử dụng cài đặt cổng thanh toán của quản trị viên. Cấu hình cổng thanh toán của bạn dưới đây để ghi đè lên chúng.',
    paymentGatewayOverrideHint: 'Nhập giá trị để ghi đè lên cài đặt quản trị',
    mapsPlatform: {
      title: 'Nền tảng bản đồ',
      description: 'Cấu hình nền tảng bản đồ ưa thích của bạn để chọn vị trí.',
      google: {
        title: 'Google Maps',
        apiKey: 'Khóa API Google Maps',
        enabled: 'Sử dụng Google Maps'
      },
      mapbox: {
        title: 'Mapbox',
        apiKey: 'Token truy cập Mapbox',
        enabled: 'Sử dụng Mapbox'
      }
    },
    publicCharging: {
      title: 'Chỉ định công cộng',
      description: 'Cho phép người dùng thêm địa điểm',
      allowUserAddLocation: 'Cho phép người dùng thêm địa điểm',
      allowUserAddLocationDescription: 'Cho phép người dùng thêm địa điểm vào bản đồ',
      allowUserAddLocationError: 'Lỗi khi cập nhật cài đặt điểm sạc công cộng',
      allowUserAddLocationSuccess: 'Cài đặt điểm sạc công cộng đã được cập nhật thành công',
    },
    objectStorage: {
      title: 'Cài đặt lưu trữ đối tượng',
      enabled: 'Kích hoạt lưu trữ đối tượng',
      enabledDescription: 'Lưu trữ tệp được tải lên trong lưu trữ đối tượng S3 thay vì máy chủ cục bộ',
      provider: 'Nhà cung cấp lưu trữ',
      providerDescription: 'Chọn nhà cung cấp lưu trữ để sử dụng',
      endpoint: 'URL điểm cuối',
      endpointDescription: 'URL điểm cuối S3 (ví dụ: https://s3.amazonaws.com)',
      bucket: 'Tên thùng',
      bucketDescription: 'Tên thùng S3 để lưu trữ tệp',
      accessKey: 'Khóa truy cập',
      accessKeyDescription: 'Khóa truy cập AWS hoặc tương đương',
      secretKey: 'Khóa bí mật',
      secretKeyDescription: 'Khóa bí mật AWS hoặc tương đương',
      cdnUrl: 'URL CDN',
      cdnUrlDescription: 'URL CDN tùy chọn (ví dụ: https://cdn.example.com)',
      region: 'Khu vực',
      regionDescription: 'Khu vực AWS hoặc tương đương (ví dụ: us-east-1)',
    }
  },
  payment: {
    momo: 'Momo',
    vnpay: 'VNPay',
    zalopay: 'ZaloPay',
    enabled: 'Kích hoạt',
    partnerCode: 'Mã đối tác',
    accessKey: 'Khóa truy cập',
    secretKey: 'Khóa bí mật',
    returnUrl: 'URL trả về',
    notifyUrl: 'URL thông báo (IPN)',
    tmnCode: 'Mã TMN',
    hashSecret: 'Khóa hash',
    appId: 'ID ứng dụng',
    key1: 'Khóa 1',
    key2: 'Khóa 2',
    environment: {
      label: 'Môi trường',
      development: 'Phát triển',
      production: 'Sản phẩm'
    }
  },
  locations: {
    title: 'Địa điểm',
    addLocation: 'Thêm địa điểm',
    editLocation: 'Sửa địa điểm',
    name: 'Tên',
    mapLocation: 'Vị trí trên bản đồ',
    selectOrManualEdit: 'Chọn hoặc chỉnh sửa thủ công',
    address: 'Địa chỉ',
    ward: 'Phường/Xã',
    district: 'Quận/Huyện',
    city: 'Thành phố/Tỉnh',
    country: 'Quốc gia',
    coordinates: 'Tọa độ',
    status: 'Trạng thái',
    operator: 'Nhà điều hành',
    locationName: 'Tên địa điểm',
    streetAddress: 'Địa chỉ đường',
    stateProvince: 'Tỉnh',
    postalCode: 'Mã bưu điện',
    latitude: 'Vĩ độ',
    longitude: 'Kinh độ',
    workingHours: {
      title: 'Giờ làm việc',
      openingTime: 'Giờ mở cửa',
      closingTime: 'Giờ đóng cửa'
    },
    contact: {
      title: 'Thông tin liên hệ',
      phone: 'Số điện thoại',
      website: 'Trang web'
    },
    amenities: {
      title: 'Tiện ích',
      waitingRoom: 'Phòng chờ',
      parking: 'Bãi đậu xe',
      restroom: 'Nhà vệ sinh',
      wifi: 'WiFi',
      drinks: 'Đồ uống',
      food: 'Thức ăn',
      park: 'Công viên',
      restaurant: 'Nhà hàng',
      shoppingMall: 'Trung tâm mua sắm'
    },
    images: {
      title: 'Hình ảnh',
      maxLimit: 'Tối đa 6',
      addUrls: 'Hoặc thêm URL hình ảnh (Mỗi dòng một URL)',
      preview: 'Địa điểm',
      remove: 'Xóa hình ảnh',
      confirmRemove: 'Bạn có chắc chắn muốn xóa hình ảnh này?',
    },
    locationStatus: {
      active: 'Hoạt động',
      inactive: 'Không hoạt động',
      maintenance: 'Bảo trì',
      pending: 'Chờ duyệt',
      approved: 'Đã duyệt',
      rejected: 'Từ chối',
    },
    confirmApprove: 'Bạn có chắc chắn muốn duyệt địa điểm này?',
    confirmReject: 'Bạn có chắc chắn muốn từ chối địa điểm này?',
    confirmDelete: 'Bạn có chắc chắn muốn xóa địa điểm này?',
    cannotDelete: 'Không thể xóa địa điểm này',
    map: {
      search: 'Tìm kiếm địa điểm',
      useMyLocation: 'Sử dụng vị trí của tôi',
      locating: 'Đang xác định vị trí...',
      pickFromMap: 'Chọn vị trí từ bản đồ',
      hideMap: 'Ẩn bản đồ',
      country: 'Quốc gia',
      province: 'Tỉnh/Thành phố',
      district: 'Quận/Huyện',
      ward: 'Phường/Xã',
      street: 'Đường',
      streetPlaceholder: 'Nhập địa chỉ đường'
    },
    search: 'Tìm kiếm địa điểm',
    allStatuses: 'Tất cả trạng thái',
    allOperators: 'Tất cả nhà điều hành',
  },
  validation: {
    required: 'Trường này là bắt buộc',
    invalidEmail: 'Địa chỉ email không hợp lệ',
    passwordMismatch: 'Mật khẩu không khớp',
    minLength: 'Phải có ít nhất {{count}} ký tự',
    maxLength: 'Phải có nhiều nhất {{count}} ký tự',
  },
  chargePoints: {
    title: 'Điểm sạc',
    addChargePoint: 'Thêm điểm sạc',
    editChargePoint: 'Sửa điểm sạc',
    setPassword: 'Thiết lập mật khẩu',
    copyUrl: 'Sao chép URL',
    urlDetails: 'Chi tiết URL',
    ipDomain: 'IP Domain',
    path: 'Đường dẫn',
    authKey: 'Khóa xác thực',
    noPassword: 'Không có mật khẩu',
    noPasswordHint: 'Để trống để tắt mật khẩu',
    chargePointId: 'ID điểm sạc',
    name: 'Tên',
    location: 'Địa điểm',
    currentLocation: 'Địa điểm hiện tại',
    searchLocation: 'Tìm kiếm địa điểm',
    searchAndSelectLocation: 'Tìm kiếm và chọn địa điểm',
    searchLocationPlaceholder: 'Nhập tên để tìm kiếm địa điểm',
    typeToSearchLocations: 'Nhập tên để tìm kiếm địa điểm',
    enterSearchTerms: 'Nhập từ khóa tìm kiếm',
    noLocationsFound: 'Không tìm thấy địa điểm',
    locationsFound: 'Tìm thấy địa điểm',
    vendor: 'Nhà cung cấp',
    selectVendor: 'Chọn nhà cung cấp',
    model: 'Model',
    mode: {
      title: 'Mode',
      public: 'Công cộng',
      private: 'Riêng tư'
    },
    vehicleType: {
      title: 'Loại xe',
      motorbike: 'Xe máy',
      car: 'Xe hơi',
      both: 'Cả hai'
    },
    type: 'Loại',
    power: 'Công suất (kW)',
    connector: 'Loại đầu nối',
    price: 'Giá',
    status: 'Trạng thái',
    connectors: 'Đầu nối',
    selectLocation: 'Chọn địa điểm',
    priceSchedules: 'Lịch giá',
    startTime: 'Thời gian bắt đầu',
    endTime: 'Thời gian kết thúc',
    addTimePrice: 'Thêm giá theo thời gian',
    remove: 'Xóa',
    connectorId: 'ID đầu nối',
    addConnector: 'Thêm đầu nối',
    qrCode: {
      title: 'Mã QR cho đầu nối #{{number}}',
      download: 'Tải mã QR',
      print: 'In mã QR'
    },
    chargePointStatus: {
      available: 'Sẵn sàng',
      'in-use': 'Đang sử dụng',
      maintenance: 'Bảo trì',
      offline: 'Ngoại tuyến'
    },
    connectorStatus: {
      Available: 'Sẵn sàng',
      Preparing: 'Đang chuẩn bị',
      Charging: 'Đang sạc',
      SuspendedEVSE: 'EVSE tạm dừng',
      SuspendedEV: 'EV tạm dừng',
      Finishing: 'Đang kết thúc',
      Reserved: 'Đã đặt trước',
      Unavailable: 'Không khả dụng',
      Faulted: 'Lỗi'
    },
    connectorTypes: {
      Type1: 'Type 1',
      Type2: 'Type 2',
      CHAdeMO: 'CHAdeMO',
      CCS: 'CCS',
      CCS2: 'CCS2'
    },
    chargeTypes: {
      AC: 'AC',
      DC: 'DC'
    },
    controls: {
      restart: 'Khởi động lại',
      unlock: 'Mở khóa',
      lock: 'Khóa'
    },
    password: {
      title: 'Mật khẩu',
      set: 'Thiết lập mật khẩu',
      remove: 'Xóa mật khẩu',
      current: 'Mật khẩu hiện tại',
      new: 'Mật khẩu mới',
      confirm: 'Xác nhận mật khẩu',
      manage: 'Quản lý mật khẩu'
    },
    confirmations: {
      delete: 'Bạn có chắc chắn muốn xóa điểm sạc này?',
      restart: 'Bạn có chắc chắn muốn khởi động lại điểm sạc này?',
      unlock: 'Bạn có chắc chắn muốn mở khóa đầu nối {{number}}?',
      lock: 'Bạn có chắc chắn muốn khóa đầu nối {{number}}?'
    },
    messages: {
      noPrice: 'Chưa thiết lập giá',
      pricePerKwh: '/kWh',
      enterChargePointId: 'Nhập ID điểm sạc duy nhất',
      noLocation: 'Không xác định',
      noVendor: 'Không xác định',
      selectVendor: 'Chọn nhà cung cấp',
      vendorRequired: 'Vui lòng chọn nhà cung cấp',
      createSuccess: 'Điểm sạc được tạo thành công',
      updateSuccess: 'Điểm sạc được cập nhật thành công',
      saveError: 'Lỗi khi lưu điểm sạc',
      enterNewPassword: 'Nhập mật khẩu mới',
      currentPassword: 'Mật khẩu hiện tại',
      newPassword: 'Mật khẩu mới',
      confirmPassword: 'Xác nhận mật khẩu',
      passwordOptional: 'Đây là tùy chọn, để trống để giữ nguyên',
      leaveUnchanged: 'Giữ nguyên',
      typeToSearch: 'Nhập tên để tìm kiếm'
    },
    search: 'Tìm kiếm điểm sạc',
    allStatuses: 'Tất cả trạng thái',
    allOperators: 'Tất cả nhà điều hành',
    allTypes: 'Tất cả loại',
    allVehicleTypes: 'Tất cả loại xe'
  },
  rfidTags: {
    title: 'Thẻ RFID',
    addTag: 'Thêm thẻ mới',
    editTag: 'Sửa thẻ RFID',
    tagId: 'ID thẻ',
    type: 'Loại',
    user: 'Người dùng',
    status: 'Trạng thái',
    expiryDate: 'Ngày hết hạn',
    lastUsed: 'Lần sử dụng cuối',
    description: 'Mô tả',
    assignUser: 'Gán cho người dùng',
    selectUser: 'Chọn người dùng',
    unassigned: 'Chưa gán',
    never: 'Chưa bao giờ',
    types: {
      personal: 'Cá nhân',
      public: 'Công cộng'
    },
    tagStatus: {
      active: 'Hoạt động',
      blocked: 'Đã khóa',
      expired: 'Hết hạn'
    },
    actions: {
      block: 'Khóa',
      activate: 'Kích hoạt'
    },
    messages: {
      saveSuccess: 'Lưu thẻ RFID thành công',
      saveError: 'Lỗi khi lưu thẻ RFID',
      deleteError: 'Lỗi khi xóa thẻ RFID',
      updateError: 'Lỗi khi cập nhật trạng thái thẻ',
      fetchError: 'Lỗi khi tải danh sách thẻ RFID',
      usersFetchError: 'Lỗi khi tải danh sách người dùng'
    }
  },
  transactions: {
    title: 'Giao dịch sạc',
    columns: {
      user: 'Người dùng',
      chargePoint: 'ID điểm sạc:Đầu nối',
      startTime: 'Thời gian bắt đầu',
      endTime: 'Thời gian kết thúc',
      energy: 'Năng lượng (kWh)',
      fee: 'Phí',
      status: 'Trạng thái'
    },
    status: {
      active: 'đang hoạt động',
      suspended: 'tạm dừng',
      completed: 'hoàn thành',
      failed: 'thất bại'
    },
    messages: {
      fetchError: 'Lỗi khi tải danh sách giao dịch',
      inProgress: 'Đang thực hiện',
      publicTag: 'Thẻ công cộng',
      unknownCharger: 'Không xác định',
      unknownTag: 'Không xác định',
      noTransactions: 'Không có giao dịch'
    },
    filters: {
      operator: 'Nhà điều hành',
      status: 'Trạng thái',
      chargePoint: 'Điểm sạc',
      user: 'Người dùng',
      allStatuses: 'Tất cả trạng thái',
      allOperators: 'Tất cả nhà điều hành',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      reset: 'Đặt lại'
    },
    totalCount: 'Hiển thị {{showing}} trong tổng số {{total}} giao dịch',
    activeCount: 'Giao dịch đang hoạt động: {{count}}'
  },
  users: {
    title: 'Người dùng',
    addUser: 'Thêm người dùng mới',
    editUser: 'Sửa người dùng',
    columns: {
      name: 'Tên',
      username: 'Tên đăng nhập',
      email: 'Email',
      phone: 'Điện thoại',
      status: 'Trạng thái',
      createdAt: 'Ngày tạo',
      actions: 'Hành động'
    },
    status: {
      active: 'hoạt động',
      inactive: 'không hoạt động'
    },
    actions: {
      activate: 'Kích hoạt',
      deactivate: 'Vô hiệu hóa',
      delete: 'Xóa',
      edit: 'Sửa'
    },
    messages: {
      fetchError: 'Lỗi khi tải danh sách người dùng',
      deleteError: 'Lỗi khi xóa người dùng',
      updateError: 'Lỗi khi cập nhật trạng thái người dùng',
      saving: 'Đang lưu...',
      deleteConfirmation: 'Bạn có chắc chắn muốn xóa người dùng này? Hành động này không thể hoàn tác.',
      rfidTagsWarning: 'Người dùng này có các thẻ RFID sau đây. Vui lòng xóa các thẻ này trước khi xóa người dùng:',
      deleting: 'Đang xóa...'
    },
    modal: {
      passwordNote: '(để trống nếu giữ nguyên)',
      form: {
        username: 'Tên đăng nhập',
        email: 'Email',
        password: 'Mật khẩu',
        name: 'Tên',
        phone: 'Điện thoại'
      }
    },
    rfidTags: {
      title: 'Thẻ RFID liên kết',
      columns: {
        tagId: 'ID thẻ',
        status: 'Trạng thái',
        expiryDate: 'Ngày hết hạn',
        actions: 'Hành động'
      },
      actions: {
        manage: 'Quản lý thẻ RFID',
        close: 'Đóng'
      }
    }
  },
  layout: {
    title: 'Sạc xe điện',
    navigation: {
      dashboard: 'Bảng điều khiển',
      operators: 'Nhà điều hành',
      vendors: 'Nhà cung cấp',
      locations: 'Địa điểm',
      areas: 'Khu vực hành chính',
      chargePoints: 'Điểm sạc',
      transactions: 'Giao dịch',
      users: 'Người dùng',
      rfidTags: 'Thẻ RFID',
      pendingImages: 'Hình ảnh chờ duyệt',
      settings: 'Cài đặt',
      notifications: 'Thông báo',
      signOut: 'Đăng xuất'
    },
    actions: {
      signOut: 'Đăng xuất'
    },
    footer: {
      copyright: '© 2024 Nền tảng sạc xe điện v1.0.2 - Đã đăng ký bản quyền.'
    }
  },
  operators: {
    title: 'Quản lý nhà điều hành',
    addOperator: 'Thêm nhà điều hành',
    editOperator: 'Cập nhật nhà điều hành',
    columns: {
      name: 'Tên',
      email: 'Email',
      phone: 'Điện thoại',
      company: 'Công ty',
      status: 'Trạng thái',
      paymentType: 'Hình thức thanh toán',
      createdAt: 'Ngày tạo',
      actions: 'Hành động'
    },
    form: {
      name: 'Tên',
      email: 'Email',
      phone: 'Điện thoại',
      company: 'Công ty',
      status: 'Trạng thái',
      paymentType: 'Hình thức thanh toán',
      password: 'Mật khẩu (tùy chọn)',
      googlePlayLink: 'Google Play Store Link',
      appStoreLink: 'App Store Link',
      appGalleryLink: 'AppGallery Link',
      statusOptions: {
        active: 'Hoạt động',
        inactive: 'Không hoạt động'
      },
      paymentOptions: {
        prepaid: 'Trả trước',
        postpaid: 'Trả sau'
      }
    },
    actions: {
      edit: 'Sửa',
      delete: 'Xóa',
      save: 'Lưu',
      cancel: 'Hủy'
    },
    messages: {
      fetchError: 'Không thể tải danh sách nhà điều hành',
      createSuccess: 'Tạo nhà điều hành thành công!',
      updateSuccess: 'Cập nhật nhà điều hành thành công!',
      deleteSuccess: 'Xóa nhà điều hành thành công',
      deleteConfirm: 'Bạn có chắc chắn muốn xóa nhà điều hành này?',
      loginCredentials: 'Thông tin đăng nhập:\nEmail: {{email}}\nMật khẩu: {{password}}',
      saving: 'Đang lưu...'
    }
  },
  login: {
    title: {
      firstLogin: 'Tạo tài khoản quản trị đầu tiên',
      normal: 'Chào mừng trở lại! Vui lòng đăng nhập'
    },
    version: 'v1.0.2',
    firstLoginMessage: 'Đây là lần đăng nhập đầu tiên. Tài khoản của bạn sẽ được tạo với quyền quản trị.',
    form: {
      username: 'Tên đăng nhập hoặc Email',
      adminUsername: 'Tên đăng nhập quản trị',
      password: 'Mật khẩu'
    },
    actions: {
      createAdmin: 'Tạo tài khoản quản trị',
      signIn: 'Đăng nhập',
      processing: 'Đang xử lý...'
    },
    errors: {
      invalidCredentials: 'Thông tin đăng nhập không hợp lệ'
    }
  },
  vendors: {
    title: 'Quản lý nhà cung cấp',
    description: 'Quản lý nhà cung cấp và thông tin về nhà cung cấp.',
    addVendor: 'Thêm nhà cung cấp',
    editVendor: 'Sửa nhà cung cấp',
    deleteConfirmation: 'Bạn có chắc chắn muốn xóa nhà cung cấp này?',
    table: {
      name: 'Tên nhà cung cấp',
      website: 'URL trang web',
      status: 'Trạng thái',
      actions: 'Hành động',
    },
    modal: {
      addTitle: 'Thêm nhà cung cấp',
      editTitle: 'Sửa nhà cung cấp',
    },
    messages: {
      createSuccess: 'Tạo nhà cung cấp thành công!',
      updateSuccess: 'Cập nhật nhà cung cấp thành công!',
      deleteSuccess: 'Xóa nhà cung cấp thành công',
      saveError: 'Lỗi khi lưu nhà cung cấp',
      deleteError: 'Lỗi khi xóa nhà cung cấp',
      fetchError: 'Lỗi khi tải danh sách nhà cung cấp',
    }
  },
  wallet: {
    balance: 'Số dư',
    topUp: 'Nạp tiền',
    paymentMethods: {
      title: 'Phương thức thanh toán',
      momo: 'Momo',
      vnpay: 'VNPay',
      zalopay: 'ZaloPay',
      postpaid: 'Trả sau',
      account: 'Tài khoản'
    },
    // ... rest of wallet translations ...
  },
  areas: {
    title: 'Khu vực hành chính',
    addArea: 'Thêm khu vực',
    editArea: 'Sửa khu vực',
    searchPlaceholder: 'Tìm kiếm khu vực...',
    root: 'Gốc',
    fields: {
      name: 'Tên',
      type: 'Loại',
      code: 'Mã',
      status: 'Trạng thái',
      latitude: 'Vĩ độ',
      longitude: 'Kinh độ'
    },
    types: {
      province: 'Tỉnh',
      city: 'Thành phố',
      district: 'Quận/Huyện',
      ward: 'Phường/Xã'
    },
    status: {
      active: 'Hoạt động',
      inactive: 'Không hoạt động'
    },
    messages: {
      deleteConfirm: 'Bạn có chắc chắn muốn xóa khu vực này?',
      createSuccess: 'Tạo khu vực thành công',
      updateSuccess: 'Cập nhật khu vực thành công',
      deleteSuccess: 'Xóa khu vực thành công',
      error: 'Đã xảy ra lỗi'
    }
  },
  admin: {
    settings: 'Cài đặt',
    notifications: 'Thông báo',
    sendPushNotifications: 'Gửi Thông báo đẩy',
    notificationType: 'Loại thông báo',
    notificationTypeHelp: 'Chọn loại thông báo để gửi. Người dùng sẽ chỉ nhận được thông báo họ đã bật trong tùy chọn của họ.',
    notificationTypes: {
      userMessaging: 'Tin nhắn người dùng',
      appUpdate: 'Cập nhật ứng dụng',
      newStation: 'Trạm sạc mới'
    },
    targetTypes: {
      selected: 'Người dùng đã chọn',
      role: 'Người dùng theo vai trò',
      all: 'Tất cả người dùng'
    },
    roles: {
      user: 'Người dùng',
      admin: 'Quản trị viên',
      operator: 'Nhà điều hành'
    },
    selectUsers: 'Chọn người dùng',
    deselectAll: 'Bỏ chọn tất cả',
    selectAll: 'Chọn tất cả',
    noUsersWithPushTokens: 'Không tìm thấy người dùng có token thông báo đẩy',
    selectedUsers: 'Đã chọn {{count}} người dùng',
    notificationTitlePlaceholder: 'Nhập tiêu đề thông báo',
    notificationMessagePlaceholder: 'Nhập nội dung thông báo',
    imageUrl: 'URL hình ảnh',
    imageUrlHelp: 'Hình ảnh để hiển thị với thông báo (phải công khai truy cập được)',
    sendNotifications: 'Gửi thông báo'
  },
}; 